"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const formik_1 = require("formik");
const react_native_paper_dates_1 = require("react-native-paper-dates");
const styles_1 = __importDefault(require("../../styles/styles"));
const button_1 = __importDefault(require("../button/button"));
const eventConstants_1 = require("../../constants/eventConstants");
const utils_1 = require("../../utils/utils");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const select_1 = __importDefault(require("../select/select"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const officersSlice_1 = require("../../features/officer/officersSlice");
const ticketUtils_1 = require("../ticketComponent/ticketUtils");
const SchedulesSlice_1 = require("../../features/schedules/SchedulesSlice");
const filterCallRecordConstants_1 = require("../filterCallRecord/filterCallRecordConstants");
const filterPersistentScheduleConstants_1 = require("./filterPersistentScheduleConstants");
const themes_1 = __importDefault(require("../../styles/themes"));
const pressable_1 = __importDefault(require("../pressable/pressable"));
const FilterTopUserEngagementSchedule = ({ queryParams, setQueryParams, }) => {
    const today = new Date();
    const dispatch = useAppDispatch_1.default();
    const { officer, officers } = useAppSelector_1.default((state) => ({
        officer: state.auth.user,
        officers: state.officers.officers.data,
    }));
    const [selectedSortBy, setSelectedSortBy] = react_1.useState();
    const [selectedStatus, setSelectedStatus] = react_1.useState();
    const [callDateAfter, setCallDateAfter] = react_1.useState(queryParams.call_date_after ? new Date(queryParams.call_date_after) : undefined);
    const [callDateAfterModalVisible, setCallDateAfterModalVisible] = react_1.useState(false);
    const formattedcallDateAfter = callDateAfter && utils_1.formatDateISOString(callDateAfter);
    const [callDateBefore, setCallDateBefore] = react_1.useState(queryParams.call_date_before ? new Date(queryParams.call_date_before) : undefined);
    const [callDateBeforeModalVisible, setCallDateBeforeModalVisible] = react_1.useState(false);
    const formattedcallDateBefore = callDateBefore && utils_1.formatDateISOString(callDateBefore);
    react_1.useEffect(() => {
        dispatch(officersSlice_1.getOfficers({}));
    }, []);
    const officerChoices = ticketUtils_1.generateOfficerChoices(officers);
    const onSearch = (input) => ticketUtils_1.searchOfficers(dispatch, input);
    const onCallDateAfterModalConfirm = (params) => {
        setCallDateAfterModalVisible(false);
        setCallDateAfter(params.date);
    };
    const onCallDateBeforeModalConfirm = (params) => {
        setCallDateBeforeModalVisible(false);
        setCallDateBefore(params.date);
    };
    const onSubmit = (payload) => {
        const updatedPayload = {
            ...payload,
            status: selectedStatus,
            order_by: selectedSortBy,
            call_date_after: formattedcallDateAfter,
            call_date_before: formattedcallDateBefore,
        };
        dispatch(SchedulesSlice_1.getTopUserEngagementSchedules(updatedPayload));
        setQueryParams(updatedPayload);
    };
    const getFieldValue = (field, value) => {
        const formattedField = utils_1.formatTitle(field);
        if (field === 'officer_id') {
            const officerMappings = utils_1.mapStatusChoices(officerChoices);
            const label = officerMappings.get(value);
            return [label ? 'Officer' : formattedField, label || value];
        }
        if (field === 'status') {
            const statusMappings = utils_1.mapStatusChoices(filterPersistentScheduleConstants_1.SCHEDULE_STATUSES_CHOICES);
            const label = statusMappings.get(value);
            return [label ? 'Status' : formattedField, label || value];
        }
        if (field === 'order_by') {
            const sortChoicesMappings = utils_1.mapStatusChoices(filterPersistentScheduleConstants_1.ORDER_BY_CHOICES);
            const label = sortChoicesMappings.get(value);
            return [label ? 'Sorted ' : formattedField, label || value];
        }
        if (field === 'external_id') {
            return ['User UUID ', value];
        }
        if (filterCallRecordConstants_1.FIELD_MAPPING.has(field)) {
            const labelMapping = filterCallRecordConstants_1.FIELD_MAPPING.get(field);
            return [formattedField, labelMapping.get(value) || value];
        }
        return [formattedField, value];
    };
    return (react_1.default.createElement(react_native_paper_1.Card, { style: [styles_1.default.whiteBackground] },
        react_1.default.createElement(react_native_paper_1.Card.Title, { title: "Filters", titleStyle: styles_1.default.textColorBlack }),
        react_1.default.createElement(react_native_paper_1.Card.Content, null,
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.flexWrap] }, Object.entries(queryParams).map(([field, value]) => !utils_1.isEmptyOrUndefined(value) &&
                field !== 'page' &&
                field !== 'officer_id' && (react_1.default.createElement(react_native_paper_1.Chip, { key: field, style: [styles_1.default.blueBackground, styles_1.default.marginFive], textStyle: styles_1.default.textColorWhite, mode: "outlined", onClose: () => {
                    setQueryParams({ ...queryParams, [field]: undefined });
                    dispatch(SchedulesSlice_1.getTopUserEngagementSchedules({ ...queryParams, [field]: undefined }));
                } }, getFieldValue(field, value).join(' is '))))),
            react_1.default.createElement(formik_1.Formik, { initialValues: queryParams, onSubmit: (values) => onSubmit(values), validateOnChange: false }, ({ handleSubmit, handleChange, values }) => (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.flexWrap] },
                    react_1.default.createElement(react_native_paper_dates_1.DatePickerModal, { locale: "en", mode: "single", visible: callDateAfterModalVisible, onDismiss: () => setCallDateAfterModalVisible(false), date: callDateAfter, onConfirm: onCallDateAfterModalConfirm, label: "Select call date after", validRange: {
                            endDate: today,
                        } }),
                    react_1.default.createElement(react_native_paper_dates_1.DatePickerModal, { locale: "en", mode: "single", visible: callDateBeforeModalVisible, onDismiss: () => setCallDateBeforeModalVisible(false), date: callDateAfter, onConfirm: onCallDateBeforeModalConfirm, label: "Select call date before", validRange: {
                            endDate: today,
                        } }),
                    officer.is_manager && (react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(select_1.default, { value: values.officer_id, setValue: () => { }, setValueFormik: handleChange('officer_id'), choices: officerChoices, searchable: true, onSearch: onSearch }))),
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(select_1.default, { value: selectedSortBy, setValue: setSelectedSortBy, choices: filterPersistentScheduleConstants_1.ORDER_BY_CHOICES, style: { height: 60 } })),
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(select_1.default, { value: selectedStatus, setValue: setSelectedStatus, choices: filterPersistentScheduleConstants_1.SCHEDULE_STATUSES_CHOICES, style: { height: 60 } })),
                    react_1.default.createElement(react_native_paper_1.TextInput, { label: "User UUID", onChangeText: handleChange('external_id'), value: values.external_id || '', style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
                    react_1.default.createElement(react_native_paper_1.TextInput, { label: "Minimum Call Count", onChangeText: handleChange('min_call_count'), value: values.min_call_count || '', style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
                    react_1.default.createElement(react_native_paper_1.TextInput, { label: "Maximum Call Count", onChangeText: handleChange('max_call_count'), value: values.max_call_count || '', style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
                    react_1.default.createElement(pressable_1.default, { onPress: () => setCallDateAfterModalVisible(true), eventName: eventConstants_1.SELECT_SCHEDULE_CALL_DATE_AFTER_BUTTON },
                        react_1.default.createElement(react_native_paper_1.TextInput, { label: "Call Date From", value: formattedcallDateAfter, left: true, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput })),
                    react_1.default.createElement(pressable_1.default, { onPress: () => setCallDateBeforeModalVisible(true), eventName: eventConstants_1.SELECT_SCHEDULE_CALL_DATE_BEFORE_BUTTON },
                        react_1.default.createElement(react_native_paper_1.TextInput, { label: "Call Date Before", value: formattedcallDateBefore, left: true, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }))),
                react_1.default.createElement(react_native_paper_1.Card.Actions, null,
                    react_1.default.createElement(button_1.default, { onPress: handleSubmit, eventName: eventConstants_1.SCHEDULES_FILTER_BUTTON, text: `Filter ` }))))))));
};
exports.default = FilterTopUserEngagementSchedule;
